import { render, staticRenderFns } from "./WireGuardTemplate.vue?vue&type=template&id=6b91c87a"
import script from "./WireGuardTemplate.vue?vue&type=script&lang=js"
export * from "./WireGuardTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports